const deadlineAtDateFormatterMinimal = 'D MMMM';

export default deadlineAtDateFormatterMinimal;
